import { useTranslation } from 'react-i18next';
import { Badge, type BadgeTone } from '@/components/ui/badge';

interface PortalStatusPillProps {
  status: string;
}

const TONE: Record<string, BadgeTone> = {
  registered: 'success',
  invited: 'warning',
  not_invited: 'muted',
};

export function PortalStatusPill({ status }: PortalStatusPillProps) {
  const { t } = useTranslation('clients');
  const tone = TONE[status] === undefined ? TONE.not_invited : TONE[status];
  return (
    <Badge tone={tone} className="shrink-0">
      {t('portalStatus.' + status)}
    </Badge>
  );
}
